import { TransactionCard } from '@/components'
import { useHostZoneQuery } from './queries'
import { CHAIN_INFO_LIST } from '@/config'
import { useSelectedDenom } from '../../contexts/denom'

const StakeChainHaltedCard = () => {
  const { data } = useHostZoneQuery()

  const [denom] = useSelectedDenom()

  if (!data?.halted) {
    return null
  }

  return (
    <TransactionCard
      status="warning"
      title={`st${denom} is turned off at the moment`}
      description={`Liquid staking and unstaking for ${CHAIN_INFO_LIST[denom].chainName} has been disabled temporarily due to chain halting.`}
    />
  )
}

export { StakeChainHaltedCard }
